module.exports = __webpack_public_path__ + "img/Notification.f576327c.svg";